import { Box, Stack, Typography } from '@mui/material'
import SectionContainer from './SectionContainer'
import { SectionTemplate } from '../types'
import TrajectoryLines from '../charts/TrajectoryLines'
import { PATH_COLORS } from '../palette'

interface YearPoint {
  year: number
  value: number
}

interface Path {
  title?: string
  trajectory?: YearPoint[]
  narrative?: string
}

interface Props {
  template: SectionTemplate
  values: { paths?: Path[] }
  title: string
  description: string
  sectionNumber?: number
}

const PALETTE = PATH_COLORS

export default function ChartTrajectorySection({ template, values, title, description, sectionNumber }: Props) {
  const paths = values?.paths || []
  const series = paths.map((p, i) => ({
    label: p.title || `Path ${i + 1}`,
    color: PALETTE[i % PALETTE.length],
    data: p.trajectory || [],
  }))

  return (
    <SectionContainer
      id={template.sectionTypeId}
      number={sectionNumber}
      title={title}
      description={description}
    >
      <Stack spacing={4}>
        <TrajectoryLines series={series} />
        <Stack spacing={3}>
          {paths.map((p, i) =>
            p.narrative ? (
              <Box key={i}>
                <Typography
                  variant="overline"
                  sx={{ color: PALETTE[i % PALETTE.length], letterSpacing: 2, fontSize: 11 }}
                >
                  {p.title}
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5, lineHeight: 1.6, maxWidth: 880 }}>
                  {p.narrative}
                </Typography>
              </Box>
            ) : null
          )}
        </Stack>
      </Stack>
    </SectionContainer>
  )
}
